"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionElementBehaviour_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionRestrictionElement_1 = require("./PermissionRestrictionElement");
var PermissionRestrictionPoint_1 = require("./PermissionRestrictionPoint");
var PermissionElementBehaviour_Factory = /** @class */ (function () {
    function PermissionElementBehaviour_Factory() {
    }
    PermissionElementBehaviour_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionElementBehaviourId: model.PermissionElementBehaviourId,
            PermissionRestrictionElement: PermissionRestrictionElement_1.PermissionRestrictionElement_Factory.CreateIncoming(model.PermissionRestrictionElement),
            PermissionRestrictionElementId: model.PermissionRestrictionElementId,
            PermissionRestrictionPoint: PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateIncoming(model.PermissionRestrictionPoint),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
            Precedence: model.Precedence,
        };
        return result;
    };
    PermissionElementBehaviour_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionElementBehaviourId: model.PermissionElementBehaviourId,
            PermissionRestrictionElement: PermissionRestrictionElement_1.PermissionRestrictionElement_Factory.CreateOutgoing(model.PermissionRestrictionElement),
            PermissionRestrictionElementId: model.PermissionRestrictionElementId,
            PermissionRestrictionPoint: PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateOutgoing(model.PermissionRestrictionPoint),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
            Precedence: model.Precedence,
        };
        return result;
    };
    return PermissionElementBehaviour_Factory;
}());
exports.PermissionElementBehaviour_Factory = PermissionElementBehaviour_Factory;
